import { render } from "./CustomerLoyalty.vue?vue&type=template&id=d3aa2e76&scoped=true"
import script from "./CustomerLoyalty.vue?vue&type=script&lang=js"
export * from "./CustomerLoyalty.vue?vue&type=script&lang=js"

import "./CustomerLoyalty.vue?vue&type=style&index=0&id=d3aa2e76&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d3aa2e76"

export default script